import{a as e}from"./chunk-QEKOZYJ5.js";import{a as r}from"./chunk-RAAYCPUM.js";function u(...n){return r(a,n)}var a=(n,t)=>e(n,o=>o<=t);export{u as a};
